// extracted by css-extract-rspack-plugin
export default {"root":"root-kAQfrl","mainContainer":"mainContainer-vNyiwd"};